import { Map, fromJS } from 'immutable';
import { RestAPI } from '@/util/net.js';
import { putError } from '@/store/error.store';
import { markStoreLoading, markStoreLoaded } from '@/store/storeForStoringStatusOfStores.store';

export const unlinkedRegionsReducer = (state = new Map(), action) => {
  switch (action.type) {
    case 'UNLINKED_REGIONS_LOADED':
      return state.set('data', fromJS(action.data));
    case 'UPDATE_UNLINKED_REGIONS_FIELD':
      return state.set(action.field, action.value);
    case 'UNLINKED_REGIONS_REPORT_CLEAR':
      return new Map();
    default:
      return state;
  }
};

export const generateReport = (dispatch, filterDto) => {
  markStoreLoading(dispatch, 'POSITION_MAP');
  dispatch({ type: 'LOADING_UNLINKED_REGIONS' });
  return RestAPI.post('/api/report/getregionunlinked', filterDto)
    .then(
      (data) => {
        dispatch({ type: 'UNLINKED_REGIONS_LOADED', data });
        markStoreLoaded(dispatch, 'POSITION_MAP');
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'UNLINKED_REGIONS_LOADING_FAILED' });
        markStoreLoaded(dispatch, 'POSITION_MAP');
        return true;
      },
    );
};

export const updateField = (dispatch, field, value) =>
  dispatch({ type: 'UPDATE_UNLINKED_REGIONS_FIELD', field, value });

export const clearReport = dispatch => dispatch({ type: 'UNLINKED_REGIONS_REPORT_CLEAR' });
